import type React from "react";
import type { ValidationResult } from "../types/scoring.ts";

interface ProjectSubmitFormProps {
  handle: string;
  onHandleChange: (value: string) => void;
  validation: ValidationResult | null;
  validating: boolean;
  submitting: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

export function ProjectSubmitForm({
  handle,
  onHandleChange,
  validation,
  validating,
  submitting,
  onSubmit,
}: ProjectSubmitFormProps) {
  return (
    <>
      <form className="score-form" onSubmit={onSubmit}>
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="Enter Twitter Handle or URL"
            value={handle}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onHandleChange(e.target.value)}
            spellCheck={false}
            autoComplete="off"
            disabled={submitting}
          />
          {validating && <span className="input-status validating" />}
          {!validating && validation?.valid && (
            <span
              className={`input-status ${validation.isCryptoProject === false ? "warning" : "valid"}`}
            />
          )}
          {!validating && validation && !validation.valid && (
            <span className="input-status invalid" />
          )}
        </div>
        <button type="submit" className="btn" disabled={submitting || validating}>
          {submitting || validating
            ? "Validating..."
            : validation?.existing
              ? validation.existing.lastAuditedAt
                ? "Rescore"
                : "Score Project"
              : "Score Project"}
        </button>
      </form>

      {validation && !validating && (
        <div
          className={`validation-feedback ${validation.valid ? (validation.existing?.lastAuditedAt ? "warning" : validation.isCryptoProject === false ? "warning" : "valid") : "invalid"}`}
        >
          {!validation.valid && <span>{validation.error || "Invalid handle"}</span>}
          {validation.valid && validation.existing && validation.existing.lastAuditedAt && (
            <div className="validation-stats">
              <span className="validation-stat">
                Already scored — Score:{" "}
                {validation.existing.score != null
                  ? Number(validation.existing.score).toFixed(1)
                  : "N/A"}
              </span>
              {validation.existing.confidence != null && (
                <span className="validation-stat">
                  Confidence: {(Number(validation.existing.confidence) * 100).toFixed(0)}%
                </span>
              )}
              <span className="validation-stat">
                Last scored: {new Date(validation.existing.lastAuditedAt).toLocaleDateString()}
              </span>
              <span className="validation-stat" style={{ color: "var(--accent)" }}>
                Click &quot;Rescore&quot; to re-score this project
              </span>
            </div>
          )}
          {validation.valid && validation.existing && !validation.existing.lastAuditedAt && (
            <div className="validation-stats">
              <span className="validation-stat">Already in pipeline — not yet scored</span>
            </div>
          )}
          {validation.valid && !validation.existing && validation.moniData && (
            <div className="validation-stats">
              <span className="validation-stat">
                Moni Score: {validation.moniData.moniScore.toLocaleString()}
              </span>
              <span className="validation-stat">
                Smart Followers: {validation.moniData.smartsCount.toLocaleString()}
              </span>
              {validation.isCryptoProject === false && (
                <span className="validation-stat">Not recognized as crypto project</span>
              )}
            </div>
          )}
          {validation.valid && !validation.existing && !validation.moniData && (
            <span>Handle valid ({validation.handle})</span>
          )}
        </div>
      )}
    </>
  );
}
